import { IconButton } from '@sparemin/blockhead';
import styled from 'styled-components';

export const HelpButton = styled(IconButton).attrs({
  color: 'tertiary',
})`
  height: 20px;
  width: 20px;
`;
